import React from 'react';
import InputField from '../../components/UI/Forms/InputField';
import { FieldValues, useForm } from 'react-hook-form';
import ErrorMessage from '../../components/UI/Notifications/ErrorMessage';
import Button from '../../components/UI/Buttons/Button';
import { validationSchema } from '../../utility/validation';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL } from '../../api/constant';
import { showToastNotification } from '../../utility/helper';

const ResetPassword: React.FC = () => {
    const { register, handleSubmit, formState: { errors }, watch } = useForm({ mode: 'onBlur' });

    const onSubmit = (data: FieldValues) => {
        let postData = {
            "email": data.email,
            "phone": '',
            "deviceId": "",
            "deviceToken": ""
        }
        const response: any = callApi(API_URL + API_ENDPOINT.auth + `user/reset-password/${'token'}`, { data: postData, method: 'POST' });
        if (response.status === true) {

        } else {
            showToastNotification('danger', response.message)
        }
    };

    return (
        <div className='app app-login p-0'>
            <div className="row g-0 app-auth-wrapper">
                <div className="col-12 col-md-7 col-lg-6 auth-main-col text-center p-5">
                    <div className="d-flex flex-column align-content-end">
                        <div className="app-auth-body mx-auto">
                            <div className="app-auth-branding mb-4">
                                <a className="app-logo" href="javascript:void(0)">
                                    <img className="logo-icon me-2" src="/assets/images/app-logo.svg" alt="logo" />
                                </a>
                            </div>
                            <h2 className="auth-heading text-center mb-5">Reset Password</h2>
                            <div className="auth-form-container text-start">
                                <form className="auth-form reset-password-form" onSubmit={handleSubmit(onSubmit)} >
                                    <div className="password mb-3">
                                        <label className="sr-only" htmlFor="reset-password">New Password</label>
                                        <InputField
                                            register={register('password', {
                                                required: validationSchema.password.required,
                                                pattern: {
                                                    value: validationSchema.password.pattern.regex,
                                                    message: validationSchema.password.pattern.message
                                                }
                                            })}
                                            name="password"
                                            type="password"
                                            className="reset-password"
                                            placeholder="New Password"
                                        />
                                        <ErrorMessage message={errors.password?.message?.toString()} className='text-danger' />
                                    </div>
                                    <div className="password-confirm mb-3">
                                        <label className="sr-only" htmlFor="confirm-password">Confirm Password</label>
                                        <InputField
                                            register={register('confirmPassword', {
                                                required: validationSchema.password.required,
                                                validate: value => value === watch('password') || validationSchema.password.match,
                                            })}
                                            name="confirmPassword"
                                            type="password"
                                            className="confirm-password"
                                            placeholder="Confirm Password"
                                        />
                                        <ErrorMessage message={errors.confirmPassword?.message?.toString()} className='text-danger' />
                                    </div>
                                    <div className="text-center">
                                        <Button type="submit" loading={false} className="app-btn-primary w-100 theme-btn mx-auto" text='Reset Password' />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
                    <div className="auth-background-holder"></div>
                    <div className="auth-background-mask"></div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
